import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import dayjs from "dayjs";
import { GiMoneyStack } from "react-icons/gi";
import LoadingSpinner from "../../component/Loader/LoadingSpinner";
import {
  useLazyGetKitchenReceiptQuery,
} from "../../redux/features/order/orderApi";
import { useDebounce } from "use-debounce";
import DatePicker from "react-multi-date-picker";
import { AdminCashier } from "../../Protect/HiddenLink";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/auth/AuthSlice";

const KitchenReceipt = () => {
 const user = useSelector(selectUser);
  const [values, setValues] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);
  const startStr = values?.[0];
  const endStr = values?.[1];
  const startDateFilter = startStr ? new Date(startStr) : null;
  const endDateFilter = endStr ? new Date(endStr) : null;
  const [
    triggerGetOrders,
    { data: kitchenReceiptData, isLoading: orderLoading, isFetching: orderFetching },
  ] = useLazyGetKitchenReceiptQuery();
  const orders = kitchenReceiptData?.data;

  const displayedOrders =
  user?.role === "counter"
    ? orders?.slice(0, 30) // latest 30
    : orders;

  useEffect(() => {
    triggerGetOrders({
      search: debouncedSearch,
      startDate: startDateFilter?.toISOString(),
      endDate: endDateFilter?.toISOString(),
    });
  }, []);

  const handleFetchOrders = () => {
    triggerGetOrders({
      search: debouncedSearch,
      startDate: startDateFilter?.toISOString(),
      endDate: endDateFilter?.toISOString(),
    });
  };

  const [groupedOrders, setGroupedOrders] = useState({});
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [visibleDates, setVisibleDates] = useState({});
  const printRef = useRef();

  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;
  const serviceCharges = process.env.REACT_APP_SERVICE_CHARGES;




  const toggleDateVisibility = (date) => {
    setVisibleDates((prev) => ({
      // ...prev,
      [date]: !prev[date],
    }));
  };

  useEffect(() => {
    if (displayedOrders && displayedOrders.length > 0) {
      const grouped = displayedOrders.reduce((acc, order) => {
        const orderDate = dayjs(order.createdAt).format("D MMMM YYYY (dddd)");
        if (!acc[orderDate]) {
          acc[orderDate] = [];
        }
        acc[orderDate].push(order);
        return acc;
      }, {});

      setGroupedOrders(grouped);
    }
  }, [displayedOrders]);

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
  
  };


  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;
  
  const handlePrint = () => {
    const printContent = printRef.current;

    if (!printContent) return;

    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return "";
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
         <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles}  ${printStyles}
          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
           
            }
            .text-[.8rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
  };

 
  return (
    <>
      {(orderLoading || orderFetching ) && (
        <LoadingSpinner />
      )}

      <div className="flex flex-col h-screen bg-[#F1F1F1]">
        <div>
          <Navbar page="Kitchen Receipts" />
        </div>
        <div className="flex h-full overflow-hidden">
          <div className="lg:w-[30%] md:w-[39%] w-[35%] overflow-y-auto scrollbar-hide bg-white shadow-md">
            {/* <OrderList /> */}
            <div className="w-full flex flex-col">
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="outline-none md:p-4 p-2 md:text-[1rem] text-[.7rem] w-full"
                placeholder="Search by order no"
              />
              <AdminCashier>
              <div className="flex items-center justify-between w-full">
                <DatePicker
                  value={values}
                  onChange={setValues}
                  range
                  rangeHover
                  format="YYYY/MM/DD"
                  render={(value, openCalendar) => (
                    <input
                      readOnly
                      onClick={openCalendar}
                      value={value}
                      placeholder="Select date range"
                      className="outline-none flex-grow p-2 md:text-[1rem] text-[.7rem] w-full"
                    />
                  )}
                />
                <button
                  className=" px-4 py-2 bg-[#0d868c] text-white  "
                  onClick={handleFetchOrders}
                >
                  Filter
                </button>
              </div></AdminCashier>
            </div>
            <div>
              {Object.entries(groupedOrders)?.map(([date, orders]) => (
                <div key={date}>
                  <div
                    onClick={() => toggleDateVisibility(date)}
                    className={`md:px-6 px-2 lg:px-8 bg-[#7D7D7D] text-white md:py-3 py-2 text-[9px] md:text-[11px] lg:text-[13px] font-bold cursor-pointer ${
                      visibleDates[date] ? "" : "border-b border-white"
                    }`}
                  >
                    {date}
                  </div>
                  <div
                    className={`overflow-hidden transition-max-height duration-500 ${
                      visibleDates[date] ? "h-max" : "max-h-0"
                    }`}
                  >
                    {orders.map((order) => (
                      <div
                        key={order._id}
                        onClick={() => handleOrderClick(order)}
                        className={`border-b md:px-6 px-2 lg:px-8 md:py-2 py-1.5 flex items-center cursor-pointer ${
                          selectedOrder && selectedOrder._id === order._id
                            ? "bg-[#0D868C] "
                            : ""
                        }`}
                      >
                        <GiMoneyStack
                          className={`md:size-8 size-5 md:mr-3 mr-1.5  ${
                            selectedOrder && selectedOrder._id === order._id
                              ? "text-white "
                              : "text-[#0D868C]"
                          }`}
                        />{" "}
                        <div className="order-info">
                          <div
                            className={`lg:text-[1rem] md:text-[.8rem] text-[.6rem] font-semibold ${
                              selectedOrder && selectedOrder._id === order._id
                                ? "text-white "
                                : "text-[#1E1E1E]"
                            }`}
                          >
                        
                             #{order.orderNo}
                          </div>
                          <div
                            className={`lg:text-[.75rem] md:text-[.6rem] text-[.5rem] font-semibold ${
                              selectedOrder && selectedOrder._id === order._id
                                ? "text-[white] "
                                : "text-[#A9A9A9]"
                            }`}
                          >
                            {dayjs(order.createdAt).format("h:mm A")}
                          </div>
                        </div>
                        
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* card */}
          <div className="flex-1 lg:p-8 py-6 overflow-y-auto  relative flex flex-col justify-between">
            <div className="lg:w-full w-[40rem] mx-auto ">
              {selectedOrder ? (
                <div>
                  <div className="flex justify-center items-center">
                    <div className="lg:py-6 py-4 px-4 w-[75%] lg:w-[60%] mx-auto bg-white shadow-md rounded-xl flex flex-col gap-4">
                      <div className="flex items-stretch justify-between gap-2">
                        <span className="bg-[#0d868c] text-white py-2 px-4 rounded-md w-max capitalize">
                         {selectedOrder?.isDeleted ? "Deleted" : selectedOrder?.orderStatus}
                        </span>
                     
                        <button
                          onClick={handlePrint}
                          className="bg-[#0d868c] text-white py-2 px-4 rounded-md w-max"
                        >
                          Print
                        </button>
                      </div>

                      {/* Top Section */}
                      <div className="w-full text-center">
                        <h1 className="lg:text-[2.75rem] text-[2rem] font-bold text-[#1E1E1E]">
                          #{selectedOrder.orderNo}
                        </h1>
                        <h2 className="text-[#0D868C] lg:text-[1rem] text-[.8rem] font-bold capitalize">
                         Order No
                        </h2>
                      </div>

                      {/* Lower Top Section */}
                      <div className="flex justify-between items-center border-y border-[#0D868C] lg:p-4 p-3">
                        <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal">
                          Order Taken By:{" "}
                          <span className="capitalize">
                            {selectedOrder.username}
                          </span>
                        </p>
                        <p className="text-[#1E1E1E] lg:text-[14px] text-[12px] font-normal capitalize">
                          Table No: {selectedOrder.tableNo}
                        </p>
                      </div>
                      {/* Middle Section */}
                      <div>
                        {selectedOrder?.products?.map((item, index) => (
                          <div
                            key={item._id}
                            className={`flex items-center w-full lg:gap-6 gap-4 p-2 ${
                              index !== 0 ? "border-t border-[#DEDEDE]" : ""
                            }`}
                          >
                            <div className="flex flex-col flex-1 gap-1">
                              <h2 className="text-[#0D868C] text-[.8rem] lg:text-[1rem] font-semibold capitalize">
                                {item?.name}{" "}
                              </h2>
                              {item?.name?.includes("deal") && (
                                <h2 className="text-[#0D868C] text-[.7rem] capitalize">
                                  {item?.description}{" "}
                                </h2>
                              )}
                            </div>
                            <div className="flex items-center justify-between w-[35%] text-[#A9A9A9] text-[.8rem] lg:text-[1rem]">
                              <p className="w-[40%]">X{item.quantity}</p>
                              <p>
                                {priceSymbol}{" "}
                                {(item.price * item.quantity).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* Upper Lower Section */}
                     
                      {/* Lower Section */}
                      <div className="flex justify-between items-center text-[#A9A9A9] lg:text-[12px] text-[10px] lg:px-4 px-3 py-2">
                        <p>
                          {dayjs(selectedOrder.createdAt).format(
                            "D /M /YYYY . h:mm A",
                          )}
                        </p>
                        <p>#{selectedOrder.orderNo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <p className="text-[#A9A9A9] pl-4">
                    Click on an order to view details.
                  </p>
                </div>
              )}
            </div>

         
          </div>
        </div>
        <div className="hidden invisible">
          <div ref={printRef} className="flex justify-center items-center ">
            <div className="bg-white mx-1 flex flex-col ">
              <div className="text-center mx-auto">
                <h1 className="w-full text-[1rem] text-center uppercase tracking-[.1em] ">
                  Restaurant Bill
                </h1>
              </div>

              <div className=" py-2  rounded-xl flex flex-col gap-1  ">
                {selectedOrder?.orderNo && (
                  <h1 className="w-full text-[.8rem] my-2 text-center uppercase tracking-[.1em] ">
                    Invoice #{selectedOrder.orderNo}
                  </h1>
                )}

                {/* Lower Top Section */}
                <div className="flex flex-col gap-1 border-y  border-[#000] py-1 px-1">
                  <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                    Order Taken By:{" "}
                    <span className="capitalize">
                      {selectedOrder?.username}
                    </span>
                  </p>
                  <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                    Table No: {selectedOrder?.tableNo}
                  </p>
                </div>

                {/* Middle Section */}
                <div className="border border-[#000]">
                  <div
                    className={`flex items-center w-full  border-b border-[#000]`}
                  >
                    <div className="flex items-center justify-between w-full text-black text-[.7rem]  tracking-[.1em]  ">
                      <p className="w-[30%]  text-center py-1">Qty</p>
                      <p className="w-[35%] border-x border-[#000] text-center py-1">
                        Rate
                      </p>
                      <p className="w-[35%]  text-center py-1">Total</p>
                    </div>
                  </div>
                  {selectedOrder?.products?.map((item, index) => (
                    <div
                      key={item._id}
                      className={`flex items-start flex-col w-full 
                      `}
                    >
                      <div className="flex flex-col flex-1 gap-1 pl-1">
                        <h2 className="text-black text-[.7rem]  uppercase tracking-[.1em] ">
                          {index + 1}. {item?.name}{" "}
                        </h2>
                        {item?.name?.includes("deal") && (
                          <h2 className="text-black text-[.6rem] uppercase tracking-[.1em] ">
                            {item?.description}{" "}
                          </h2>
                        )}
                      </div>
                      <div
                        className={`flex items-center justify-between w-full  ${
                          index !== selectedOrder?.products?.length - 1
                            ? "border-y"
                            : "border-t"
                        }  border-[#000] text-black text-[.7rem] uppercase tracking-[.1em]  `}
                      >
                        <p className="w-[30%] text-center ">{item?.quantity}</p>
                        <p className="w-[35%] border-x border-[#000] text-center ">
                          {item?.price}
                        </p>
                        <p className="w-[35%] text-center ">
                          {item?.price * item?.quantity}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="text-[.75rem]  uppercase tracking-widest  text-center">
                  Thank You for Visiting
                </div>

                <div className="text-[.7rem] uppercase tracking-[.1em]  text-center w-full">
                  Powered By Eastern Tech
                  {/* <img src={ETLogo} alt="" /> */}
                </div>
                {/* Lower Section */}
                <div className="flex justify-center items-center text-black  text-[14px] uppercase tracking-[.1em]  pb-6">
                  <p>
                    {dayjs(selectedOrder?.createdAt).format(
                      "D /M /YYYY . h:mm A",
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KitchenReceipt;
